export const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
};

 export function toGMT8DDMMYYYY(date){
        if(!date)return '';
        //return 'dd/mm/yyyy' in GMT+8 timezone
        let d = new Date(date);
        d = new Date(d.getTime() + (3600000*8));
        let month = '' + (d.getUTCMonth() + 1);
        let day = '' + d.getUTCDate();
        let year = d.getUTCFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [day, month, year].join('/');
    }
export function toGMT8HHMMSS(date){
        if(!date)return '';
        //return 'hh:mm:ss' in GMT+8 timezone
        let d = new Date(date);
        d = new Date(d.getTime() + (3600000*8));
        let hours = '' + d.getUTCHours()
        let minutes = '' + d.getUTCMinutes();
        let seconds = '' + d.getUTCSeconds();

        if (hours.length < 2) hours = '0' + hours;
        if (minutes.length < 2) minutes = '0' + minutes;
        if (seconds.length < 2) seconds = '0' + seconds;

        return [hours, minutes, seconds].join(':');
    }